<template>
      <div >
        <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
        <br/>
        <span style="color:#909399;font-size: 13px; margin-left: 50px;">{{$t('analyse.accountDataTable.updateTime')}} {{time}}</span>
        <div id="main" style="width:90%; height: 500px; margin-top: 50px; margin-left: 20px;"></div>

        <span style="color:#909399;font-size: 15px; font-weight: bold; margin-left: 50px;">{{$t('analyse.accountDataTable.detail')}}</span>
        <el-button type="primary" style="float:right;"  @click="exportData()"  v-auth="'analyse:chshinMoney:export'">{{$t('analyse.accountDataTable.export')}}</el-button>
        <el-table  :data="tableData" style="width: 100%;margin-left: 70px;"  :default-sort = "{prop: 'date', order: 'descending'}">
          <el-table-column  prop="amountMoney"  :label="$t('analyse.depositMoneyTable.amountMoney')"    />
          <el-table-column  prop="amountAccountCount"  :label="$t('analyse.depositMoneyTable.amountMoney')"  sortable/>
          <el-table-column  prop="amountCount"  :label="$t('analyse.depositMoneyTable.amountCount')"  sortable/>
        </el-table>
      </div>

</template>

<script>
    //存款平台
    let inChannels={};
    //存款方式
    let payWays={};
    //table封装组件
    import URL from '@/views/analyse/util/url'
    import FORM from '@/components/page/form.vue'
    import download from '@/utils/download'
    import DateUtil from '@/utils/IM/tradeDataUtil.js'
    import Qs from 'qs'
    import axios from 'axios'
    import echarts from 'echarts'
    export default {
        components: {
            FORM
        },
        data() {
            return {
                tableData:{},
                time:'',

                formData:{
                    cols:[
                        { title: window.$t('analyse.depositTable.time'), field: 'time',type:6},
                        { title: window.$t('analyse.depositTable.inChannel'), field: 'inChannel',type:2,optionList:this.inChannels},
                        { title: window.$t('analyse.depositTable.payWay'), field: 'payWay',type:2,optionList:this.payWays},
                        {click:window.$t("common.search"),auth:'analyse:chshinMoney:sel'}
                    ]
                },

            }
        },
        mounted(){
            this.$axios.get(URL.chshinAnalyseVn.getData).then(res => {
                if (res.code == 0) {
                    this.inChannels=res.result.inChannels;
                    this.payWays=res.result.payWays;
                    this.formData.cols =[
                        { title:  window.$t('analyse.depositTable.time'), field: 'time',type:6},
                        { title: window.$t('analyse.depositTable.inChannel'), field: 'inChannel',type:2,optionList:this.inChannels},
                        { title: window.$t('analyse.depositTable.payWay'), field: 'payWay',type:2,optionList:this.payWays},
                        {click:window.$t("common.search"),auth:'analyse:chshinMoney:sel'}
                    ];
                }
            });
                },
        methods: {
            checkbox(row){
                this.deleteIds = row.map(key => key.id).join(",");
            },
            exportData(){
                let startTime=null;
                let endTime=null;
                if(this.formData.cols[0].data!=undefined){
                    startTime=this.formData.cols[0].data[0];
                    endTime=this.formData.cols[0].data[1];
                }
                let inChannel=this.formData.cols[1].data;
                let payWay=this.formData.cols[2].data;
                if((startTime!=undefined && endTime!=undefined) ||inChannel!=undefined||payWay!=undefined) {
                    if (inChannel == undefined)
                        inChannel = "";
                    if (payWay == undefined)
                        payWay = "";
                    if (startTime == undefined)
                        startTime = null;
                    if (endTime == undefined)
                        endTime = null;
                    let urlLast = "";
                    if (startTime != null && endTime != null) {
                        urlLast = "&startTime=" + startTime + "&endTime=" + endTime;
                        download.exportExcel(URL.chshinAnalyseVn.depositMoneyExport + "?payWay=" + payWay + "&inChannel=" + inChannel + urlLast, {}, "账户存款信息");
                    } else {
                        download.exportExcel(URL.chshinAnalyseVn.depositMoneyExport, {}, "存款分布信息");
                    }
                }else {
                    download.exportExcel(URL.chshinAnalyseVn.depositMoneyExport, {}, "存款分布信息");
                }
            },
            //柱图
            drawDar(id,optionVar) {
                this.charts = echarts.init(document.getElementById(id));

                // 指定图表的配置项和数据
               // var option = {
               //      title: {
               //          text: '存款金额分布'
               //      },
               //      tooltip: {
               //          trigger: 'axis',
               //          axisPointer: {
               //              type: 'shadow'
               //          }
               //      },
               //      grid: {
               //          left: '3%',
               //          right: '10%',
               //          bottom: '55%',
               //          containLabel: true
               //      },
               //      xAxis: {
               //          type: 'value',
               //          boundaryGap: [0, 0.01]
               //      },
               //      yAxis: {
               //          type: 'category',
               //          data: ['巴西', '印尼', '美国', '印度', '中国', '世界人口(万)']
               //      },
               //      series: [
               //          {
               //              type: 'bar',
               //              data: [18203, 23489, 29034, 104970, 131744, 630230]
               //          }
               //      ]
               //  };

                this.charts.setOption(optionVar);
            }, /*查询表单按钮点击事件*/
            formclick(clickName, data){
                if(clickName == "查询"  || window.$t("common.search") == clickName){
                    this.getDeposit(data);
                }
            },
            getDeposit(data){
                if((data.timeStart!=undefined && data.timeEnd!=undefined)||data.inChannel!=undefined||data.payWay!=undefined) {
                    if (data.inChannel == undefined)
                        data.inChannel = "";
                    if (data.payWay == undefined)
                        data.payWay = "";
                    if(data.timeStart==undefined)
                        data.timeStart=null;
                    if(data.timeEnd==undefined)
                        data.timeEnd=null;
                    let urlLast="";
                    if(data.timeStart!=null && data.timeEnd !=null){
                        urlLast="&startTime=" + data.timeStart + "&endTime=" +  data.timeEnd;
                    }
                    this.$axios.get(URL.chshinAnalyseVn.getDepositMoney + "?payWay=" + data.payWay + "&inChannel=" + data.inChannel+urlLast).then(res => {
                        if (res.code == 0) {
                            this.time = res.result.time;
                            this.tableData = res.result.details;
                            let drawDar = res.result.drawDar;
                            this.$nextTick(function () {
                                this.drawDar('main', drawDar);
                            });
                        }
                    });
                }else{
                    this.$axios.get(URL.chshinAnalyseVn.getDepositMoney).then(res => {
                        if (res.code == 0) {
                            let drawDar = res.result.drawDar;
                            this.time = res.result.time;
                            this.tableData = res.result.details;
                            this.$nextTick(function () {
                                this.drawDar('main', drawDar);
                            });
                        }

                    });
                }
            }
        }

    }
</script>
